import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { UserData, UserRole } from "../../actions/authentificationActions";
import { AppState } from "../../store/configureStore";
import { getUsers } from "../../api/users";
import { UsersTable } from "./UsersTable";
import { AddUserForm } from "./AddUserForm";
import { toast } from "../..";
import { useIntl } from "react-intl";
import "./UsersDashboard.css";

export const UsersDashboard = () => {
    const user = useSelector((state: AppState) => state.user);
    const [users, setUsers] = useState<UserData[]>([]);
    const intl = useIntl();

    const fetchUsers = useCallback(async () => {
        try {
            const res = await getUsers();
            setUsers(res);
        } catch {
            toast(intl.formatMessage({ id: "unableToFetchUsers" }), false);
        }
    }, [intl]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    return user.role !== UserRole.PowerUser ? (
        <Redirect to="/unauthorized" />
    ) : (
        <div className="users-dashboard-container">
            <UsersTable users={users} setUsers={setUsers} fetchUsers={fetchUsers} />
            <AddUserForm users={users} setUsers={setUsers} />
        </div>
    );
};
